import React from 'react';
import ImagingToggles, { ImagingToggleProps } from './ImagingTools';
import {
  useShowOverlays,
  useShowScaleBar,
  useShowWellDropInfoPanel,
} from 'redux/hooks/experiment';
import { useWellDropCompareMode, useWellDropCompareOpacityBar } from 'redux/hooks/well';
import ECompareMode from 'enums/ECompareMode';

const AnnotationToggles = () => {
  const [showScaleBar, toggleScaleBar] = useShowScaleBar();
  const [showOverlays, toggleOverlays] = useShowOverlays();
  const { compareModeOpacityBar, setCompareModeOpacityBar } =
    useWellDropCompareOpacityBar();
  const { compareMode } = useWellDropCompareMode();
  const [showWellDropInfoPanel, toggleWellDropInfoPanel] = useShowWellDropInfoPanel();

  const annotationToggles: ImagingToggleProps[] = [
    {
      label: 'Scale Bar',
      isOn: showScaleBar,
      onToggle: toggleScaleBar,
      disabled: false,
    },
    {
      label: 'Annotation',
      isOn: showOverlays,
      onToggle: toggleOverlays,
      disabled: false,
    },
    {
      label: 'Info',
      isOn: showWellDropInfoPanel,
      onToggle: toggleWellDropInfoPanel,
      disabled: false,
    },
    ...(compareMode === ECompareMode.Overlay
      ? [
          {
            label: 'Opacity Bar',
            isOn: compareModeOpacityBar,
            onToggle: () => setCompareModeOpacityBar(!compareModeOpacityBar),
            disabled: false,
          },
        ]
      : []),
  ];
  return <ImagingToggles toggles={annotationToggles} />;
};

export default AnnotationToggles;
